import { Pipe, PipeTransform } from "@angular/core";
import { Helper } from "@helpers/functions";
import { getLocaleArray } from "@helpers/utils";

export interface UnitValue {
	precision: number;
	unit_symbol: string;
	value: string;
	unit_symbol_type: string;
}

@Pipe({
	name: "unitValueDisplay",
	standalone: false
})
export class UnitValueDisplayPipe implements PipeTransform {
	transform(data: UnitValue, showAbsolute = false): string {
		if (!data) {
			return "";
		}

		const isFiat = data.unit_symbol_type === "FIAT";

		const locales: string[] = getLocaleArray(Helper.getLanguage());

		const numberValue = showAbsolute ? Math.abs(Number(data.value)) : Number(data.value);

		let displayValue = numberValue;
		if (numberValue < 0.01 && !isFiat && data.precision === 2) {
			displayValue = 0.001;
		}

		const formattedValue = displayValue.toLocaleString(locales[0], {
			localeMatcher: "best fit",
			minimumIntegerDigits: 1,
			minimumFractionDigits: 2,
			maximumFractionDigits: data.precision
		});

		if (isFiat) {
			return `${data.unit_symbol} ${formattedValue}`;
		}
		return `${formattedValue} ${data.unit_symbol}`;
	}
}
